import {configureStore} from '@reduxjs/toolkit';
import filtersReducer from './filters/filtersSlice';
import clientsReducer from './clients/clientsSlice'

export const store = configureStore({
  reducer: {
    filters: filtersReducer,
    clients: clientsReducer,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
